import { useZocksAuth } from '../../components/ScopedBlock/hooks'

export const useCanBuySeats = () => {
  const { hasScope } = useZocksAuth()

  return hasScope('**', 'billing_subscription:change', ['billing_subscription:admin'])
}
